import { setCookie } from './toolbox';

let cookieNotice = null;

export function setCookieNotice (instance) {
	cookieNotice = instance;
}

export function isLocalStorageConsentGiven () {
	return cookieNotice?.isLocalStorageConsentGiven?.() ?? false;
}

export function requestConsent () {
	return cookieNotice?.requestConsent?.();
}

export function setConsentCookie () {
	setCookie('consent', 7);
}
